import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';

const Routes = () => {
  const { token, accessType } = useSelector((state) => state.auth);

  const result = (token && protectedRoutes[accessType]?.map((route) => route)) || [];
  return (
    <RouterRoutes>
      <Route path="/" element={<ProtectedRoute />}>
        {result?.map((route, index) => (
          <React.Fragment key={route.key}>
            <Route path="/" key={route.key} element={<Navigate replace to={route.path} />} />
            <Route key={route.key + index} path={route.path} element={<AppRoute routeKey={route.key} component={route.component} {...route.meta} />} />
          </React.Fragment>
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
      <Route path="/" element={<PublicRoute />}>
        {publicRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={<AppRoute routeKey={route.key} component={route.component} {...route.meta} />} />
        ))}
      </Route>
    </RouterRoutes>
  );
};

export default Routes;
